var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7005 0H3.29955C1.48024 0 0 1.47994 0 3.29955V13.9486C0 15.7641 1.47375 17.2417 3.28785 17.2481V22.0804L10.2325 17.2481H20.7005C22.5198 17.2481 24 15.7679 24 13.9485V3.29955C24 1.47994 22.5198 0 20.7005 0ZM22.5938 13.9485C22.5938 14.9924 21.7445 15.8419 20.7005 15.8419H9.79132L4.6941 19.3888V15.8418H3.29955C2.25555 15.8418 1.40625 14.9924 1.40625 13.9485V3.29955C1.40625 2.25544 2.25555 1.40625 3.29955 1.40625H20.7005C21.7445 1.40625 22.5938 2.25544 22.5938 3.29955V13.9485Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42334 4.96899H17.5764V6.37524H6.42334V4.96899ZM6.42334 7.96899H17.5764V9.37524H6.42334V7.96899ZM6.42334 10.969H14.0015V12.3752H6.42334V10.969Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComment);
export default __webpack_public_path__ + "static/media/add_comment.e4a977e0.svg";
export { ForwardRef as ReactComponent };var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7005 0H3.29955C1.48024 0 0 1.47994 0 3.29955V13.9486C0 15.7641 1.47375 17.2417 3.28785 17.2481V22.0804L10.2325 17.2481H20.7005C22.5198 17.2481 24 15.7679 24 13.9485V3.29955C24 1.47994 22.5198 0 20.7005 0ZM22.5938 13.9485C22.5938 14.9924 21.7445 15.8419 20.7005 15.8419H9.79132L4.6941 19.3888V15.8418H3.29955C2.25555 15.8418 1.40625 14.9924 1.40625 13.9485V3.29955C1.40625 2.25544 2.25555 1.40625 3.29955 1.40625H20.7005C21.7445 1.40625 22.5938 2.25544 22.5938 3.29955V13.9485Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42334 4.96899H17.5764V6.37524H6.42334V4.96899ZM6.42334 7.96899H17.5764V9.37524H6.42334V7.96899ZM6.42334 10.969H14.0015V12.3752H6.42334V10.969Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComment);
export default __webpack_public_path__ + "static/media/add_comment.e4a977e0.svg";
export { ForwardRef as ReactComponent };